interface CustomYAxisTickProps {
    x?: number;
    y?: number;
    payload?: {
        value: string;
    };
}

const MAX_CHARS_PER_LINE = 18; // chỉnh theo width 140
const MAX_LINES = 2;

const splitText = (text: string) => {
    const words = text.split(" ");
    const lines: string[] = [];
    let currentLine = "";

    for (const word of words) {
        if ((currentLine + " " + word).length <= MAX_CHARS_PER_LINE) {
            currentLine = currentLine ? `${currentLine} ${word}` : word;
        } else {
            lines.push(currentLine);
            currentLine = word;
        }
    }

    if (currentLine) lines.push(currentLine);

    return lines;
};

const  CustomYAxisTick: React.FC<CustomYAxisTickProps> = ({ x = 0, y = 0, payload }) => {
    if (!payload?.value) return null;

    const lines = splitText(payload.value);
    const displayLines = lines.slice(0, MAX_LINES);

    // Nếu vượt quá 2 dòng → thêm ...
    if (lines.length > MAX_LINES) {
        displayLines[MAX_LINES - 1] =
            displayLines[MAX_LINES - 1].replace(/\s+\S*$/, "") + "...";
    }

    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={0}
                y={0}
                textAnchor="end"
                dominantBaseline="middle"
                fontSize={12}
                fill="#344054"
            >
                {displayLines.map((line, index) => (
                    <tspan
                        key={index}
                        x={0}
                        dy={index === 0 ? 0 : 14} // khoảng cách giữa các dòng
                    >
                        {line}
                    </tspan>
                ))}
            </text>
        </g>
    );
};

export default CustomYAxisTick